<template>
    <section class="testing-positions-component section">
        <div class="section__header">
            <h3 class="section__title">{{ getTranslation('positions') }} - {{ pagination.total }}</h3>
            <div class="section__controls">
                <div class="section__controls-group">
                    <button v-if="hasPermission('api.testing.profile.addPosition')" @click="openModal" class="btn  btn--white  btn--system  btn--with-icon">
                        <svg class="btn__icon">
                            <use xlink:href="#icon__square-add"></use>
                        </svg>
                        {{ getTranslation('addPosition') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="section__body">
            <table class="table-3 table-borderless">
                <thead class="table-3__head">
                    <tr class="table-3__row">
                        <td class="table-3__cell  table__hcell">
                            <p class="section__descr">{{getTranslation('search')}}</p>
                        </td>
                        <td colspan="2" class="table-3__cell  table__hcell">
                            <form @submit.prevent="getPositions">
                                <input v-model="filterForm.query" type="text" class="form-control" :placeholder="getTranslation('title')" />
                            </form>
                        </td>
                        <td class="table-3__cell">
                            <button @click="getPositions" class="btn  btn--sm  btn--main">{{getTranslation('search')}}</button>
                        </td>
                    </tr>
                    <tr class="table-3__row">
                        <th class="table-3__cell  table__hcell" style="width: 0.1%;">#</th>
                        <th class="table-3__cell  table__hcell" style="width: 20%;">{{ getTranslation('title') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 25%;">{{ getTranslation('department') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 50%;">{{ getTranslation('state') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 0.2%;"></th>
                    </tr>
                </thead>
                <tbody class="table-3__body">
                    <tr v-for="item in  items" v-bind:key="item.id" class="table-3__row">
                        <td class="table-3__cell">
                            <strong>{{item.id}}</strong>
                        </td>
                        <td class="table-3__cell">
                            {{ item.positionName }}
                        </td>
                        <td class="table-3__cell">
                            <span v-if="item.department"> {{ item.department.title }}</span>
                        </td>
                        <td class="table-3__cell">
                            {{ item.stateText }}
                        </td>
                        <td class="table-3__cell">
                            <ActionsComponent :has-edit="false" :has-delete="hasPermission('api.testing.profile.removePosition')" v-on:delete="removePositionResource(item)" />
                        </td>
                    </tr>
                    <tr v-if="items.length < 1" class="table-3__row">
                        <td colspan="5" class="table-3__cell empty">
                            {{ getTranslation('notAddedYet') }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
            <pagination :pagination="pagination" @change="()=>{this.getPositions();this.$scrollTo('.testing-positions-component');}" v-model="filterForm.page"></pagination>
        </div>

        <!-- modal addPosition -->
        <modal
                v-model="showModal"
                :modal-title="getTranslation('addPosition')"
                :ok-button-label="getTranslation('save')"
                :cancel-button-label="getTranslation('cancel')"
                @ok-button-click="addPositionResource"
                @cancelButtonClick="resetModal"
                @input="resetModal"
        >

            <div v-if="showResourceTypes" class="form__group">
                <label class="form__label  form__label--block">{{ getTranslation('resourceType') }} <span class="required">*</span> </label>
                <v-select
                        :options="resourceTypes"
                        :reduce="option=>option.id"
                        label="title"
                        :placeholder="getTranslation('selectFromList')"
                        :class="{'field--error':$v.form.resourceType.$error}"
                        v-model="form.resourceType"
                />
                <div v-if="$v.form.resourceType.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
            </div>

            <div v-if="form.resourceType === POSITION_POSITIONS" class="form__group">
                <StateSelect
                        ref="stateSelect"
                        :initialValue='[null, $route.query.departmentId]'
                        :department-id.sync="departmentId"
                        :required="true"
                        :first-required="true"
                        required
                />
            </div>
            <div v-else-if="form.resourceType === LOCAL_POSITIONS" class="form__group">
                <LocalStateSelect :required="true" ref="localStateSelect" v-model="stateId" />
            </div>

            <div v-if="showResource" class="form__group">
                <label class="form__label  form__label--block">{{ getTranslation('position') }}<span class="required">*</span></label>
                <v-select
                        :options="resources"
                        :reduce="option=>option.id"
                        label="positionName"
                        :placeholder="getTranslation('selectFromList')"
                        :class="{'field--error':$v.form.resourceId.$error}"
                        v-model="form.resourceId"
                />
                <div v-if="$v.form.resourceId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
            </div>

        </modal>

    </section>
</template>

<script>
    import testingProfileMixin from "../mixins/testingProfile";
    import required from "vuelidate/lib/validators/required";
    import StateSelect from "../../../../components/shared/StateSelect";
    import LocalStateSelect from "../../../../components/shared/LocalStateSelect";
    import hrmMethods from "../../hrm/methods";

    export default {
        name: "TestingPositionsComponent",
        mixins: [testingProfileMixin],
        components: { StateSelect, LocalStateSelect },
        props: {
            testId: {
                required: true
            },
            active: {
                default: false
            }
        },
        data() {
            return {
                items: [],
                departmentId: '',
                stateId: '',
                showModal: false,
                showResourceTypes: false,
                showResource: false,
                resourceTypes: [],
                resources: [],
                POSITION_POSITIONS: 1,
                LOCAL_POSITIONS: 2,
                form: {
                    resourceId: '',
                    resourceType: '',
                },
                filterForm: {
                    page: this.$route.query.page || 1,
                },
                pagination: {
                    total: '',
                    lastPage: '',
                    currentPage: ''
                },
            }
        },
        created() {
            if ( this.active )
                this.getPositions();
        },
        watch: {
            'active'( val ) {
                if ( val )
                    this.getPositions();
            },
            'departmentId'( val ) {
                this.showResource = false;
                this.form.resourceId = '';
                if ( val && this.form.resourceType === this.POSITION_POSITIONS ) {
                    hrmMethods.fetchPositions( val ).then( positions => {
                        this.resources = positions;
                        this.showResource = true;
                    } );
                }

            },
            'stateId'( val ) {
                this.showResource = false;
                this.form.resourceId = '';
                if ( val && this.form.resourceType === this.LOCAL_POSITIONS ) {
                    this.fetchLocalPositions( val ).then( () => {
                        this.showResource = true;
                    } );
                }
            }
        },
        methods: {
            getPositions() {

                this.filterForm = this.cleanObject( this.filterForm );

                this.fetchPositions( this.testId, this.filterForm ).then( response => {

                    this.items = response.items;

                    this.filterForm.page = response.activePage;

                    this.pagination.currentPage = response.activePage;
                    this.pagination.total = response.totalItemsCount;
                    this.pagination.lastPage = response.pages;

                } )
            },
            fetchLocalPositions( stateId ) {
                return this.axios.get( this.$config.urls.state.fetchStatePositions.url.replace( ':id', stateId ) )
                           .then( response => {
                               this.resources = response.data.data;
                           } ).catch(()=>{});
            },

            addPositionResource() {
                this.$v.form.$touch();
                if ( this.$v.form.$invalid || ( this.$refs.hasOwnProperty( 'stateSelect' ) && this.$refs.stateSelect != undefined && !this.$refs.stateSelect.checkValidity() ) || ( this.$refs.hasOwnProperty( 'localStateSelect' ) && this.$refs.localStateSelect != undefined && !this.$refs.localStateSelect.checkValidity() ) )
                    return this.snotifyError( 'wrongFormMsg' );

                this.addPosition( this.testId, this.form )
                    .then( () => {
                        this.getPositions();
                        this.resetModal();
                    } )


            },

            removePositionResource( resource ) {
                let form = {
                    resourceId: resource.id,
                    resourceType: resource.type.id
                };

                this.removePosition( this.testId, form );
            },

            openModal() {
                this.fetchPositionFormOptions().then( response => {
                    this.resourceTypes = this.objectToArray( response, true );
                    this.showResourceTypes = true;
                    this.departmentId = '';
                    this.showModal = true;
                } )
            },
            resetModal() {
                this.$v.$reset();
                this.form.resourceType = '';
                this.form.resourceId = '';
                this.showModal = false;
                this.showResource = false;
                this.departmentId = '';
                this.stateId = '';
            }
        },
        validations: {

            form: {
                resourceId: {
                    required
                },
                resourceType: {
                    required
                }
            }
        }
    }
</script>

<style scoped>

</style>
